import * as PermissoesDashboard from './permissions-screens/dashboard';
import * as PermissoesArquivos from './permissions-screens/arquivos';
import * as PermissoesVendas from './permissions-screens/vendas';
import * as PermissoesVendedores from './permissions-screens/vendedores';
import * as PermissoesRelatorios from './permissions-screens/relatorios';
import * as PermissoesMetas from './permissions-screens/metas';
import * as PermissoesIntegracoes from './permissions-screens/integracoes';
import * as PermissoesRegras from './permissions-screens/regras';
import * as PermissoesDashPersonlizada from './permissions-screens/dashPersonalizada';
export const dashboard = {
  ...PermissoesDashboard
};

export const dashboardPersonalizada = {
  ...PermissoesDashPersonlizada
};

export const arquivos = {
  ...PermissoesArquivos
};

export const vendas = {
  ...PermissoesVendas
};

export const vendedores = {
  ...PermissoesVendedores
};

export const relatorios = {
  ...PermissoesRelatorios
};

export const metas = {
  ...PermissoesMetas
};

export const integracoes = {
  ...PermissoesIntegracoes
};

export const regras = {
  ...PermissoesRegras
};
